@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  background-color: @customer-auto-complete--container--background-color;
  border-radius: 4px;
  border: 1px solid @customer-auto-complete--container--border-color;
  max-height: 300px;
  overflow: auto;
  width: 350px;
  max-width: 100%;
  box-shadow: 3px 2px 2px @customer-auto-complete--container--box-shadow-color;
}

.row {
  white-space: normal;
}

.row-location {
  color: @customer-auto-complete--row--text-color;
  margin-left: 5px;
}
